import { Link } from "react-router-dom";

export function ProductTile({ p }) {
    return (
        <Link
            to={`/shop/${p.slug}`}
            className="group flex flex-col border border-[hsl(var(--dust-300))] bg-card transition-transform duration-200 hover:-translate-y-1"
            data-testid={`product-tile-${p.slug}`}
        >
            <div className="relative aspect-square overflow-hidden bg-[hsl(var(--dust-50))]">
                {p.images && p.images[0] ? (
                    <img
                        src={p.images[0]}
                        alt={p.name}
                        loading="lazy"
                        className="absolute inset-0 h-full w-full object-contain p-4 transition-transform duration-300 group-hover:scale-105"
                    />
                ) : (
                    <ProductGlyph name={p.name} />
                )}
                {p.badge && (
                    <span
                        className={`absolute left-3 top-3 px-2 py-1 font-mono-brand text-xs uppercase tracking-wider ${
                            p.badge === "SALE"
                                ? "bg-[hsl(var(--rust))] text-[hsl(var(--dust-50))]"
                                : "bg-[hsl(var(--ink))] text-[hsl(var(--primary))]"
                        }`}
                    >
                        {p.badge}
                    </span>
                )}
                {p.stock === 0 && (
                    <span className="absolute right-3 top-3 bg-[hsl(var(--ink))] px-2 py-1 font-mono-brand text-xs uppercase text-[hsl(var(--dust-50))]">
                        Sold out
                    </span>
                )}
            </div>
            <div className="flex flex-1 flex-col gap-2 p-4">
                <div className="font-mono-brand text-xs uppercase tracking-wider text-[hsl(var(--ink-soft))]">
                    {p.sku} · {p.category}
                </div>
                <h3 className="font-heading text-lg uppercase leading-tight text-[hsl(var(--ink))]">{p.name}</h3>
                <p className="text-sm text-[hsl(var(--ink-soft))]">{p.fitment}</p>
                <div className="mt-auto flex items-baseline justify-between pt-3">
                    <span className="font-display text-2xl text-[hsl(var(--ink))]">${p.price}</span>
                    <span className="font-mono-brand text-xs uppercase text-[hsl(var(--ink-soft))] group-hover:underline">
                        View details →
                    </span>
                </div>
            </div>
        </Link>
    );
}

function ProductGlyph({ name }) {
    const seed = name.length;
    return (
        <svg viewBox="0 0 200 200" className="absolute inset-0 h-full w-full p-10">
            <g fill="none" stroke="hsl(var(--dust-300))" strokeWidth="2.5" strokeLinecap="round">
                <circle cx="100" cy="100" r="70" opacity="0.25" />
                <circle cx="100" cy="100" r="50" />
                <path d={`M 30 ${100 + (seed % 20)} L 170 ${100 - (seed % 20)}`} opacity="0.5" />
                <path d="M 100 30 L 100 170" opacity="0.3" />
                <text x="100" y="108" textAnchor="middle" fontFamily="JetBrains Mono, monospace" fontSize="10" fill="hsl(var(--ink-soft))" stroke="none">
                    {name.split(" ").slice(0, 2).join(" ").toUpperCase()}
                </text>
            </g>
        </svg>
    );
}
